import React from 'react';

import { B2BMatrixContextData } from './types';

const B2BMatrixContext = React.createContext<B2BMatrixContextData>({
  items: [],
  selectAllItems: () => {
    // Nothing for now
  },
  selectNoneItems: () => {
    // Nothing for now
  },
  toggleItemSelect: (_: number) => {
    // Nothing for now
  },
  setItemCost: (_: number, __: number) => {
    // Nothing for now
  },
  setItemPrice: (_: number, __: number) => {
    // Nothing for now
  },
  toggleUseDefaultCost: () => {
    // Nothing for now
  },
  useDefaultCost: false,
});

export default B2BMatrixContext;
